import { gql } from '@apollo/client';

export default gql`
  query GetProjectCollaborations($id: ID!, $first: Int, $after: String) {
    viewer {
      id
      project(id: $id) {
        id
        name
        owningCollaborator {
          __typename
          ... on ProjectCollaboratorInterface {
            id
            name
            avatar
          }
          ... on CollaboratingCompany {
            plan {
              features {
                taskLists
              }
            }
          }
        }
        collaborations(first: $first, after: $after) {
          totalCount
          edges {
            node {
              id
              createdAt
              invitation {
                id
                creator {
                  id
                  name
                  company {
                    id
                    name
                  }
                },
                acceptedBy {
                  id
                  emailAddress
                  phoneNumber
                }
              }
              colorCode
              createdAt
              isMyCompany
              collaborator {
                __typename
                ... on ProjectCollaboratorInterface {
                  id
                  name
                  avatar
                }
                ... on CollaboratingCompany {
                  plan {
                    features {
                      taskLists
                    }
                  }
                }
              }
            }
          }
        }
        historicalCollaborations {
          id
          startedAt
          acceptedByUser {
            id
            emailAddress
            phoneNumber
          }
          owningCollaborator {
            id
            name
          }
          collaboratingCompany {
            id
            name
          }
          endedAt
        }
      }
    }
  }
`;
